<template>
    <NuxtLayout name="auth">
        <template #form>
            <ForgotPasswordWizard />
        </template>
        <template #media>
            <AuthAnimation />
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">
import AuthAnimation from '~/components/auth/AuthAnimation.vue';
import ForgotPasswordWizard from '~/pages/forgot-password/_components/ForgotPasswordWizard.vue';

definePageMeta({
  layout: false,
});
</script>